function validateRequired(value) {
  if (!value || value.length === 0) return "common.field_is_required";
}

// not used anymore?
function validateNumber(
  value,
  min = Number.MIN_SAFE_INTEGER,
  max = Number.MAX_SAFE_INTEGER
) {
  value = Number(value);
  if (isNaN(value)) return "Este campo tem de ser um número.";
  if (value > max) return "Este campo tem de ser um número menor do que " + max;
  if (value < min) return "Este campo tem de ser um número maior do que " + min;
}

function validatePhoneNumber(value) {
  const valueNumber = parseInt(value);
  if (isNaN(valueNumber)) return "common.not_a_number_error";
  if (value.length > 9) return "common.not_valid_phone_error";
  if (value.length < 9) return "common.not_valid_phone_error";
}

// TODO check :: I think this is used only by Admin
function validateInteger(
  value,
  min = Number.MIN_SAFE_INTEGER,
  max = Number.MAX_SAFE_INTEGER
) {
  value = parseInt(value);
  if (isNaN(value)) return "common.field_must_be_integer_error";
  if (value > max)
    return "common.field_must_be_integer_lesser_than_error" + max;
  if (value < min)
    return "Este campo tem de ser um inteiro maior do que " + min;
}

// TODO check :: I think this is used only by Admin
function validateDateCompare(value, date = new Date(), comparison = "lt") {
  if (value.length === 0) return "Este campo é obrigatório.";

  let dateLeft = new Date(value);
  let dateRight = new Date(date);
  let dateRightISO = dateRight.toISOString().split("T")[0];
  switch (comparison) {
    case "eq":
      if (dateLeft !== dateRight)
        return `Este campo tem de ser igual a ${dateRightISO}`;
      else break;
    case "ne":
      if (dateLeft === dateRight)
        return `Este campo não pode ser igual a ${dateRightISO}`;
      else break;
    case "gt":
      if (dateLeft <= dateRight)
        return `Este campo tem de ser depois de ${dateRightISO}`;
      else break;
    case "ge":
      if (dateLeft < dateRight)
        return `Este campo não pode ser antes de ${dateRightISO}`;
      else break;
    case "lt":
      if (dateLeft >= dateRight)
        return `Este campo tem de ser antes de ${dateRightISO}`;
      else break;
    case "le":
      if (dateLeft > dateRight)
        return `Este campo não pode ser depois de ${dateRightISO}`;
      else break;
    default:
      throw new Error(`CompareDate: Invalid comparison - ${comparison}`);
  }
}

function validateLength(value, min = 0, max, translator) {
  if(max === null) max = Number.MAX_SAFE_INTEGER;
  if (value.length < min)
    return translator("profile.password_min_characters_error", { min: min });
  if (value.length > max)
    return translator("profile.password_max_characters_error", { max: max });
}

function validateEmail(value) {
  const regex =
    /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
  if (!regex.test(value)) return "common.not_valid_email_error";
}

// TODO check :: I think this is used only by Admin
function validateLink(value, required = true) {
  if (!value && !required) return null;
  const regex =
    /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&/=]*)/gi;
  if (!regex.test(value)) return "Introduza um link válido.";
}

function validateEquals(value, other, name, translator) {
  // if (value !== other) return `Este campo tem de ser igual ao campo "${name}."`;
  if (value !== other) return translator("profile.password_update_old_not_match_error", { name: name });
}

function validateNone() {
  return null;
}

function validateChecked(value) {
  if (value) return null;
  return "register.check_box_accept_error";
}

// TODO check :: I can't make it this error show in the checkout
function validateNIF(nif) {
  if (nif) {
    // https://gist.github.com/Pipas/69ab5b514a53a494ec2a80669e950569
    if (
      !["1", "2", "3", "5", "6", "8"].includes(nif.substr(0, 1)) &&
      !["45", "70", "71", "72", "77", "79", "90", "91", "98", "99"].includes(
        nif.substr(0, 2)
      )
    )
      return "checkout.not_valid_nif_error";
    if (nif.length !== 9) return "checkout.not_valid_nif_error";

    let total =
      nif[0] * 9 +
      nif[1] * 8 +
      nif[2] * 7 +
      nif[3] * 6 +
      nif[4] * 5 +
      nif[5] * 4 +
      nif[6] * 3 +
      nif[7] * 2;

    let modulo11 = total - parseInt(total / 11) * 11;
    // eslint-disable-next-line eqeqeq
    let comparador = modulo11 == 1 || modulo11 == 0 ? 0 : 11 - modulo11;

    // eslint-disable-next-line eqeqeq
    if (nif[8] == comparador) return null;
    return "checkout.not_valid_nif_error";
  } else {
    return null;
  }
}

export {
  validateChecked,
  validateDateCompare,
  validateEmail,
  validateEquals,
  validateInteger,
  validateLength,
  validateLink,
  validateNone,
  validateNumber,
  validateRequired,
  validateNIF,
  validatePhoneNumber,
};
